import React from 'react';
import Shape from 'ati-ui-react/components/Shape';
import Skeleton from 'ati-ui-react/components/Skeleton';

import { CardStyles, Container, InfoContainer, Row } from './SkeletonMiniCardStyles';

function SkeletonMiniCard() {
  return (
    <CardStyles>
      <Shape color="white" shadow>
        <Container>
          <Skeleton width={140} height={110} />
          <InfoContainer>
            <Row>
              <Skeleton height={25} />
            </Row>
            <Row>
              <Skeleton height={20} />
            </Row>
            <Row>
              <Skeleton height={25} />
            </Row>
          </InfoContainer>
        </Container>
      </Shape>
    </CardStyles>
  );
}

export default SkeletonMiniCard;
